/* import __COLOCATED_TEMPLATE__ from './assign-conversation-to-owner.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
export default templateOnlyComponent();